import React from 'react'

const LoadingIndicator = () => (
    <div className="loadingIndicator">{/*<ScrollLock/>*/}</div>
)

export default LoadingIndicator
